import { Service } from "../../service/auth"
import { Button } from "solid-bootstrap";

export function LogoutButton() {

    function onClickLogout() {
        Service.logout();
    }

    return <Button variant="light" onClick={onClickLogout}>Log out</Button>
}